import Switch from '@material-ui/core/Switch';
import UserPrefrencesList from "./userPrefrencesList";
import { Grid } from '@material-ui/core';

const Userpreferences = ({ data }: any) => {
  const getLabel = UserPrefrencesList.filter((ele: any) => ele.access_name === data.preference_name)
  return (
    <>
      <Grid item xs={12}>
        <label>{getLabel[0].access_label}</label>
        <Switch
          checked={!data.preference_value ? false : true}
          className="access-page-switch"
          color="primary"
          name="home_page"
          inputProps={{ 'aria-label': 'primary checkbox' }}
        />
      </Grid>
    </>
  )
};

export default Userpreferences;